export const lateTypeConstants = [
  { name: "Delay", value: "delay" },
  { name: "Extreme delay", value: "extreme_delay" },
];
